module.exports = __webpack_public_path__ + "img/shoplogo.21cd6887.png";